export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./promotions-welcome-bonus.vue?vue&type=template&id=0a6eef9e"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/promotions/promotions-welcome-bonus.vue?vue&type=template&id=0a6eef9e
// module id = KCJ5
// module chunks = 0